module.exports = __webpack_public_path__ + "img/hospital-bed-empty.2360b968.jpg";